export type { IconProps } from './icon'
export type { IconTypes } from './icon'
export { default } from './icon'
